export const PATTERNS = {
    DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
    CYRILLIC: /[А-Яа-яёЁ]+/,
    CODE: /([0-9]{4})$/,
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const MESSAGES = {
    SUCCESS: {
        ALREADY_EXIST: 'Вы уже являетесь нашим клиентом. Мы восстановили Вашу карту № XXXXXX. Проверьте электронную почту',
        CREATE: 'Вы успешно зарегистрированы. Карта гостя № XXXXXX отправлена. Проверьте электронную почту',
        SMS_SEND: 'Повторите попытку через 2 минуты',
    },
    ERROR: {
        WRONG_PARAMS: 'Форма заполнена некорректно или не введен код подтверждения из СМС',
        NOT_AVAILABLE: 'Сервис временно недоступен. Повторите попытку позже',
        TRY_AGAIN: 'Обновите страницу и попробуйте заново',
    },
};

export const STATUSES = {
    SUCCESS: 'success',
    ERROR: 'error',
};
